import { Component  } from '@angular/core';

@Component({
  selector: 'app-location-denied-dialog',
  templateUrl: './location-denied-dialog.component.html',
  styleUrls: ['./location-denied-dialog.component.scss']
})
export class LocationDeniedDialogComponent {

  constructor() {
  }
}
